import React, { HTMLAttributes, useState } from 'react'

import { TrueworkLogo } from '@frame/images/truework-logo'
import { cn } from '@frame/lib/utils/cn'
import { DataAttribute } from '@frame/types'

type Props = {
  cobrandingLogoUrl?: string | null
  className?: HTMLAttributes<HTMLDivElement>['className']
}

export function HeaderLogo({ cobrandingLogoUrl, className }: Props) {
  const [hasError, setHasError] = useState(false)

  if (cobrandingLogoUrl && !hasError) {
    return (
      <img
        data-cy={DataAttribute.LOGO}
        alt="Truework logo"
        role="img"
        src={cobrandingLogoUrl}
        className={cn('h-6', className)}
        onError={() => setHasError(true)}
      />
    )
  }

  return <TrueworkLogo data-cy={DataAttribute.LOGO} className={cn('h-5', className)} />
}
